import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { userService } from '../../services/user.service'
import { motorService } from '../../services/motor.service'
import sha1 from 'js-sha1'

class CallbackPage extends Component {
  getCurrentUser = token => {
    return userService.getMe(token)
  }

  getInitial = token => {
    return motorService.getInitial(token)
  }

  componentDidMount = async () => {
    const callback = _.get(this.props, 'callback', () => {})
    const location = _.get(window, 'location', {})
    const search = _.get(location, 'search', '')
    if (search.length === 0) return true
    const splittedData = search.slice(1, search.length).split('&')
    const params = {}
    splittedData.forEach(data => {
      const splitMore = data.split('=')
      const key = _.get(splitMore, 0, '')
      const value = _.get(splitMore, 1, '')
      params[key] = value
    })
    // callback(params)
    const token = _.get(params, 'token', '')
    if (token) {
      this.getInitial(token)
        .then(response => {
          const { me = () => {}, systems = () => {} } = this.props
          const userData = _.get(response, 'current_user.data', {})
          const email = _.get(userData, 'email', '')
          const mobile = _.get(userData, 'mobile', '')
          const splittedEmail = email.split('@')
          const nameEmail = _.get(splittedEmail, 0, '')
          const hash = sha1.hex(mobile + '+' + nameEmail)
          userData.distinct_id = hash
          const mixpanel = _.get(window, 'mixpanel', undefined)
          if (!!mixpanel) {
            mixpanel.identify(hash)
          }
          me(userData)
          systems(_.get(response, 'systems', {}))
          callback({ token: _.get(response, 'tokenJWT', '') })
        })
        .catch(error => {
          if (error.message === 'Network Error') {
            const mixpanel = _.get(window, 'mixpanel', undefined)
            if (!!mixpanel) {
              mixpanel.track('Insurance Car Error', {
                'Error message': error.message,
                'Error code': 'E10301',
              })
            }
            const dataLayer = _.get(window, 'dataLayer', undefined)
            if (!!dataLayer) {
              dataLayer.push({
                event: 'error-page', // Required
                errorMsg: error.message,
              })
            }
            const {
              history: { push },
            } = this.props
            push('/error-network')
            document.getElementById("rootScreen").scrollTo(0, 0)
            return
          }
          const response = _.get(error, 'response', {})
          const responseStatus = response.status
          if (
            responseStatus === 500 ||
            responseStatus === 403 ||
            responseStatus === 401 ||
            responseStatus === 400
          ) {
            const mixpanel = _.get(window, 'mixpanel', undefined)
            if (!!mixpanel) {
              mixpanel.track('Insurance Car Error', {
                'Error message': _.get(
                  response,
                  'message',
                  'Get User - Unknown error - ' +
                    responseStatus +
                    ' ' +
                    _.get(error, 'message', '')
                ),
                'Error code': 'E10402',
              })
            }
            const dataLayer = _.get(window, 'dataLayer', undefined)
            if (!!dataLayer) {
              dataLayer.push({
                event: 'error-page', // Required
                errorMsg: _.get(
                  response,
                  'message',
                  'Get User - Unknown error - ' +
                    responseStatus +
                    ' ' +
                    _.get(error, 'message', '')
                ),
              })
            }
            const {
              history: { push },
            } = this.props
            push('/error-system')
            document.getElementById("rootScreen").scrollTo(0, 0)
            return
          }
        })
    }
    const {
      history: { push },
    } = this.props
    push('/home')
  }

  render() {
    const location = _.get(window, 'location', {})
    const search = _.get(location, 'search', '')
    const splittedData = search.slice(1, search.length).split('&')
    const params = {}
    splittedData.forEach(data => {
      const splitMore = data.split('=')
      const key = _.get(splitMore, 0, '')
      const value = _.get(splitMore, 1, '')
      params[key] = value
    })
    return <div />
  }
}
const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    callback: data => {
      dispatch({ type: 'CALLBACK', data })
    },
    me: data => {
      dispatch({ type: 'ME', data })
    },
    systems: data => {
      dispatch({ type: 'INIT', data })
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CallbackPage)
